import axios from "axios";

export const getDeviceOSTypeAPI = async params => {
  let response = await axios({
    url: `/api/v2/statistic/devices-os-type`,
    method: "GET",
    params
  });
  const deviceOSType = response.data.stat;
  return deviceOSType;
};
